
define('txt!modules/module.dealers.action.hbs',[],function () { return '<a href="{{this.action.url}}" class="btn-mod btn-mod-primary datalayer-link"{{#if this.action.target}} target="{{this.action.target}}"{{/if}}>{{this.action.title}}</a>\n';});

